import { IKeyFigure } from "src/api/server/extended-search.types";
import { MemoizedRangeSliderWithInputs } from "src/components/common/range-slider/range-slider-with-inputs";
import { IKeyFigureValue } from "src/components/pages/search/components/types";
import { handleKeyFigureChange } from "src/components/pages/search/store/actions";
import { useSearchStore } from "src/components/pages/search/store/search-store";

interface IRangeSliderListProps {
    keyFiguresData: ReadonlyArray<IKeyFigure>;
}

export const RangeSliderList = ({ keyFiguresData }: IRangeSliderListProps) => {
    const { keyFigures: storeKeyFigures } = useSearchStore();

    const handleChange = (keyFigure: IKeyFigureValue) => {
        handleKeyFigureChange({
            newKeyFigureValue: keyFigure,
            keyFiguresData,
        });
    };

    return (
        <>
            {keyFiguresData.map(({ steps, id, isUnitOfMeasurementPercentage, showPositiveLeadingSign, label, isPopular = false }) => {
                const min = steps[0];
                const max = steps[steps.length - 1];

                const selectedKeyFigure = storeKeyFigures.find(storeKeyFigure => storeKeyFigure.id === id);
                const selectedValues = selectedKeyFigure ? [selectedKeyFigure.min, selectedKeyFigure.max] : [min, max];

                return (
                    <MemoizedRangeSliderWithInputs
                        key={id}
                        label={label}
                        selectedValues={selectedValues as [number?, number?]}
                        steps={steps}
                        onChange={(minMax: number[]) => handleChange({ id, min: minMax[0], max: minMax[1], isPopular })}
                        showMarks
                        shouldShowPercentageLabel={isUnitOfMeasurementPercentage}
                        showPositiveLeadingSign={showPositiveLeadingSign}
                    />
                );
            })}
        </>
    );
};
